// Motion tokens — the canonical MedexOVA vocabulary. Every component imports from here.
// See /app/memory/DESIGN_LANGUAGE_v2.md §2.

export const DUR = {
  instant: 0.08,
  snap: 0.18,
  smooth: 0.32,
  reveal: 0.52,
  narrative: 0.86,
  grand: 1.4,
};

export const EASE = {
  emerge: [0.22, 1, 0.36, 1],
  settle: [0.16, 1, 0.3, 1],
  pop: [0.34, 1.56, 0.64, 1],
  linear: "linear",
  hold: [0.65, 0, 0.35, 1],
};

export const STAGGER = { default: 0.06, dramatic: 0.09 };

// prefers-reduced-motion helper — every component must respect this.
export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Role → accent color (§3.2).
export const ROLE_ACCENT = {
  rider: "#3B82F6",
  driver: "#F59E0B",
  broker: "#10B981",
  dispatcher: "#B45309",
  facility: "#047857",
  admin: "#8B5CF6",
  tp: "#F59E0B",
};

export const ROLE_ACCENT_GLOW = {
  rider: "rgba(59,130,246,0.42)",
  driver: "rgba(245,158,11,0.42)",
  broker: "rgba(16,185,129,0.42)",
  dispatcher: "rgba(180,83,9,0.42)",
  facility: "rgba(4,120,87,0.42)",
  admin: "rgba(139,92,246,0.42)",
  tp: "rgba(245,158,11,0.42)",
};
